module.exports = __webpack_public_path__ + "static/media/logo-vertical.fab8359c.png";